module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-body-text"
  }, [_c('div', {
    ref: "body-html",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.html)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b14650","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpText.vue
// module id = 1728
// module chunks = 37